<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :active="item.selected" @click="item.selected = !item.selected" class="list-clickable">
                <td v-if="roleEditable">
                  <v-edit-dialog
                    :return-value.sync="item.UserCode"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'UserCode': item.UserCode})"
                  >
                    <div>{{ item.UserCode }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.UserCode" label="Mã khách" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else>{{ item.UserCode }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.FirstName}}</td>
                <td>{{ item.LastName}}</td>
                <td>{{ displayPhoneNumber(item) }}</td>
                <td>{{ item.VIPName }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, customer_status)}">{{ item.Status | display_value(customer_status) }}</td>
                <td class="text-center">
                  <v-icon
                    :color="item.FinanceApproved == 1 ? 'green' : 'grey'"
                    :style="roleEditable ? 'cursor: pointer' : ''"
                    @click="toggleFinanceApproved(item)"
                    medium
                  >
                    {{ item.FinanceApproved == 1 ? 'fa-check-circle' : 'fa-circle' }}
                  </v-icon>
                </td>
                <td class="text-end">{{ item.Wallet | currency }}</td>
                <td class="text-end">{{ item.TotalTransaction | currency }}</td>
                <td>{{ item.ReceivePlaceID | display_value(warehouses, 'ID', 'Name') }}</td>
                <td v-if="roleEditable">
                  <v-edit-dialog
                    :return-value.sync="item.SalerName"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'SalerID': item.SalerID})"
                  >
                    <div>{{ item.SalerName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="sale_staffs"
                        v-model="item.SalerID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.SalerName = getStaffName(item.SalerID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!roleEditable">
                  {{ item.SalerName }}
                </td>
                <td v-if="roleEditable">
                  <v-edit-dialog
                    :return-value.sync="item.CSName"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'CustomerServiceID': item.CustomerServiceID})"
                  >
                    <div>{{ item.CSName }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="cs_staffs"
                        v-model="item.CustomerServiceID"
                        item-text="FullName"
                        item-value="ID"
                        v-on:change="item.CSName = getStaffName(item.CustomerServiceID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!roleEditable">
                  {{ item.CSName }}
                </td>
                <td>{{ item.CreatedDate | display_date('DD/MM/YYYY')}}</td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.Note" large lazy persistent @save="saveItem({'ID': item.ID, 'Note': item.Note})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.Note }}</span>
                          </template>
                          <span>{{ item.Note }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.Note" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center" v-if="!priceId">
                  <v-icon v-if="roleEditable" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                  <a 
                  target="_blank" 
                  :href="'quan-ly-khach-hang/' + item.ID"
                  ><i role="button" medium="" class="v-icon notranslate mr-2 v-icon--link theme--light" v-bind:class="roleEditable ? 'fa fa-edit' : 'fa fa-external-link-alt'"></i></a>
                </td>
                <td class="text-center" v-else>
                  <v-icon medium @click="unlinkItem(item.ID)">fa-unlink</v-icon>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <span>
                <p class="pt-2">Không có dữ liệu</p>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, confirmAction } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  props: ["priceId"],
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      search: "",
      headers: [
        {
          text: "Mã khách",
          value: "UserCode",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "User name",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Họ",
          value: "FirstName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tên",
          value: "LastName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Điện thoại",
          value: "PhoneNumber",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Level",
          value: "VIPName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.CUSTOMER_STATUS_LIST
        },
        {
          text: "Duyệt TC",
          value: "FinanceApproved",
          align: "center",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.FINANCE_APPROVED_STATUS
        },
        {
          text: "Số dư",
          value: "Wallet",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: dataType["Number"]
        },
        {
          text: "Tích lũy",
          value: "TotalTransaction",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: dataType["Number"]
        },
        {
          text: "Kho nhận",
          value: "ReceivePlaceID",
          filterable: true,
          values: [],
          dataType: dataType["Enum"]
        },
        {
          text: "NV Sale",
          value: "SalerName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Nhân viên CSKH",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
          width: "100px"
        }
      ],
      customer_status: configs.CUSTOMER_STATUS_LIST,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "customer_list",
      filterConditions: [],
      quickFilterConditions: []
    };
  },
  computed: {
    ...mapState({
      items: state => state.customer.all.data,
      total_rows: state => state.customer.all.total,
      loading: state => state.customer.loading,
      warehouses: (state) => state.commons.stores,
      staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return ((o.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      sale_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
        })
    }),
    roleEditable() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    roleConfig() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Config) == configs.ROLE_TYPE.Config;
    },
    saleScopeIds() {
      const currentUser = this.$store.state.authentication.user;
      const userId = Number(currentUser.userid);
      const scopeIds = [userId];
      const currentStaff = this.$store.state.commons.all_users.find(user => Number(user.ID) === userId);
      if (currentStaff && Number(currentStaff.IsSaleLeader || 0) === 1) {
        this.$store.state.commons.all_users.forEach(user => {
          if (Number(user.SaleLeaderID) === userId) {
            scopeIds.push(Number(user.ID));
          }
        });
      }
      return scopeIds;
    },
    canExport() {
      const currentUser = this.$store.state.authentication.user;
      return Number(currentUser.userid) === 9999991;
    }
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    warehouses() {
      let header_item = _.find(this.headers, { value: "ReceivePlaceID" });
      if (header_item) {
        header_item.values =
        _.map(this.warehouses, (item) => {
            return {
            value: item.ID,
            name: item.Name,
            };
        }) || [];
      }
    },
    roleEditable() {
      this.updateHeaderOptions();
    },
    canExport() {
      this.updateHeaderOptions();
    }
  },
  methods: {
    updateHeaderOptions() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {
        invisibleCreateButton: !this.roleEditable,
        invisibleExportButton: !this.canExport
      });
    },
    exportExcel() {
      if (!this.canExport) {
        sendErrorNotice("Bạn không có quyền xuất dữ liệu này!");
        return;
      }
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if (this.priceId) {
        param.filter.push({
          column: "PriceID",
          value: this.priceId,
          condition: "equal",
        });
      }
      this.$root.$emit('REQUEST_ROOT_OPTION', {
        exportLoading: true
      });
      this.$store.dispatch("customer/exportCustomerList", param).finally(() => {
        this.$root.$emit('REQUEST_ROOT_OPTION', {
          exportLoading: false
        });
      });
    },
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if (this.priceId) {
        param.filter.push({
          column: "PriceID",
          value: this.priceId,
          condition: "equal",
        });
      }
      this.$store.dispatch("customer/getCustomerList", param);
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "CustomerDetail",
        params: {
          Pid: id,
          title: `Khách hàng (#${id})`
        }
      });
    },
    gotoOrderList: function(id, username) {
      this.$router.push({
        name: "OrderList",
        params: {
          manualTitle: true,
          title: `Danh sách đơn hàng (${username})`
        },
        query: { uid: id }
      });
    },
    gotoWithDraw: function(username) {
      this.$router.push({
        name: "WithdrawHistory",
        query: {
          'username': username,
        }
      });
    },
    gotoRecharge: function(username) {
      this.$router.push({
        name: "RechargeHistory",
        query: {
          'username': username,
        }
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", {'id': id, 'viewName': this.viewName});
    },
    unlinkItem: function(id) {
      this.$store.dispatch("customer/setCustomerDetail", {
        'data': {PriceID: 0},
        'id': id
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      if(this.roleEditable) {
        this.$router.push({
          name: "CustomerDetail",
          params: {
            Pid: 'tao-moi',
            title: `Tạo mới khách hàng`
          }
        });
      }
      else {
        sendErrorNotice("Bạn không có quyền tạo mới khách hàng!");
      }
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    displayPhoneNumber(item) {
      const currentUser = this.$store.state.authentication.user;
      const roleType = currentUser.roletype || 0;
      const isAdmin = (roleType & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin;
      const isSale = (roleType & configs.ROLE_TYPE.Sale) === configs.ROLE_TYPE.Sale;
      const isSaleInScope = isSale && this.saleScopeIds.includes(Number(item.SalerID));
      if (isAdmin || isSaleInScope) {
        return item.PhoneNumber;
      }
      return item.PhoneNumber == null ? item.PhoneNumber : '*'.repeat(String(item.PhoneNumber).length);
    },
    saveItem(item) {
      this.$store.dispatch("customer/setCustomerDetail", {
        data: {...item},
        id: item.ID
      });
    },
    toggleFinanceApproved(item) {
      if (!this.roleEditable) return;
      const targetStateName = item.FinanceApproved == 1 ? "bỏ duyệt" : "duyệt";
      const message = `Bạn có chắc chắn muốn ${targetStateName} tài chính cho khách hàng ${item.Username}?`;
      confirmAction("ToggleFinanceApproved", item.ID, message).then((confirmed) => {
        if (confirmed) {
          const newVal = item.FinanceApproved == 1 ? 0 : 1;
          item.FinanceApproved = newVal;
          this.saveItem({ 'ID': item.ID, 'FinanceApproved': newVal });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch("commons/getAllUsers");
    this.$store.dispatch("commons/getAllStores");
    this.updateHeaderOptions();
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_EXPORT_DATA", this.exportExcel);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", item => {
      if(item.viewName == this.viewName) {
        this.$store.dispatch("customer/removeCustomerDetail", item.id);
      }
    });
  },
  beforeMount() {
    this.$store.commit("customer/setCustomerList", {data: []})
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_EXPORT_DATA", this.exportExcel);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style scoped>
a {
    text-decoration: none !important;
}
</style>
